import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-booking-segment',
  templateUrl: './smart-booking-segment.component.html',
  styleUrls: ['./smart-booking-segment.component.scss']
})
export class SmartBookingSegmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
